/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { useBlockProps } from '@wordpress/block-editor';
import isEmpty from 'lodash/isEmpty';
import ConditionalWrapper from '../../components/ConditionalWrapper';

const v1 = {
  supports: {
    html: false
  },
  attributes: {
    imageSelection: {
      default: '',
      type: 'string'
    },
    apiImage: {
      default: '',
      type: 'string'
    },
    coverAltText: {
      attribute: 'alt',
      default: '',
      selector: 'img',
      source: 'attribute',
      type: 'string'
    },
    uploadedImage: {
      default: {},
      type: 'object'
    },
    bookTitle: {
      default: '',
      type: 'string'
    },
    author: {
      default: '',
      type: 'string'
    },
    format: {
      default: '',
      type: 'string'
    },
    isbn: {
      default: '',
      type: 'string'
    },
    workId: {
      default: '',
      type: 'number'
    },
    url: {
      type: 'string',
      source: 'attribute',
      selector: 'a',
      attribute: 'href'
    },
    linkTarget: {
      type: 'string',
      source: 'attribute',
      selector: 'a',
      attribute: 'target'
    }
  },
  save({ attributes }) {
    const {
      apiImage,
      coverAltText,
      uploadedImage,
      isbn,
      bookTitle,
      author,
      workId,
      url,
      linkTarget
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__book-cover flex justify-center'
    });

    const isEmptyImage = isEmpty( uploadedImage );
    const apiImageAltText = ( coverAltText === undefined ) || ( coverAltText === '' ) ? ( `${bookTitle} by ${author} ` ).trim() : coverAltText;

    const imageClasses = !isEmptyImage ? 'shadow-book-img uploaded-image' : 'shadow-book-img api-image';
    const imageSrc = !isEmptyImage ? uploadedImage?.sizes?.full.url : apiImage;
    const imageAltText = !isEmptyImage ? uploadedImage.alt : apiImageAltText;

    return (
      imageSrc && (
        <div { ...blockProps }>
          <div className='book-cover--inner'>
            <div className="image-wrapper relative">
              <ConditionalWrapper
                condition={ url }
                // eslint-disable-next-line react/jsx-no-target-blank
                wrapper={ ( img ) => <a href={ url } target={ linkTarget ? '_blank' : null } rel={ linkTarget ? 'noopener' : null }>{ img }</a> }
              >
                <img
                  className={ imageClasses }
                  src={ imageSrc }
                  alt={ imageAltText }
                  title={ bookTitle || null }
                  data-isbn={ isbn || null }
                  data-workId={ workId || null }
                  loading='lazy'
                />
              </ConditionalWrapper>
            </div>
          </div>
        </div>
      )
    );
  }
};

export default [ v1 ];
